import React from 'react'
import {
    FormCell, CellBody, CellFooter, Switch, Button,
    CellHeader, Label, Input, Toptips, Toast, Dialog, Form, Radio,
} from 'react-weui'
import {WKGreenTitle, WKTextarea} from '../../components/wk'

import {TimeStream, storage, isLZWKAPP} from '../../utils'


class LectureBasic extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            title: '',
            startTime: '',
            showExample: false,
            showExamplePic: '',
            mode: 'picture',
        }
    }
    onFocusTime() {
        if (this.state.startTime) {
            return
        }
        setTimeout(() => {
            this.setState({startTime: ~~(Date.now() / 1000 )})
        }, 1000)
    }
    onChangeStartTime(e) {
        const value = e.target.value.replace(/-/g, "/").replace(/T/g, " ")
        const timestamp = Date.parse(value) / 1000
        this.setState({startTime: timestamp})
    }
    bindValue(e, field) {
        const value = e.target.value
        this.setState({[field]: value})
    }
    setField(field, value) {
        this.setState({[field]: value})
    }
    showExample(e) {
        let index = e.target.dataset.id;
        if (index === "0") {
            this.onChangeModeRadio(e, 'picture')
            this.setState({showExamplePic: "https://static-1253442168.image.myqcloud.com/picture/6163344_a57b5b9c646f0ea3efb9f82f78e66556.jpg"})
        } else if (index === "1") {
            this.onChangeModeRadio(e, 'ppt')
            this.setState({showExamplePic: "https://static-1253442168.image.myqcloud.com/picture/6163344_6e185561e0e63c9ab293f22e17014990.jpg"})
        } else {
            this.onChangeModeRadio(e, 'video')
            this.setState({showExamplePic: "https://static-1253442168.image.myqcloud.com/picture/6163344_695d713822c27c236801ec41ec5169f2.jpg"})
        }
        this.setState({showExample: true})
    }
    onChangeModeRadio(e, value) {
        this.setState({mode: value})
    }
    verify () {
        if (this.state.title.trim().length < 1 || this.state.title.trim().length > 40) return {
            status: false, msg: '标题长度请控制在1-40个字符之间'
        }
        if (!this.state.startTime) return { status: false, msg: '请填写开课时间' }
        return { status: true }
    }
    handleBasicSubmit() {
        const verifyRes = this.verify()
        if (!verifyRes.status) {
            return this.props.clickHandle.showTips(verifyRes.msg)
        }
        this.props.clickHandle.setStep(3)
    }
    getData() {
        return this.state
    }
    render() {
        return (
            <div className="lecture-basic">
                <div className="lecture-basic-box">
                    <WKGreenTitle title='标题' className="wk-green-specials" />
                    <Form>
                        <FormCell>
                            <CellBody>
                                <div className="lecture-basic-box__textarea">
                                    <WKTextarea
                                        value={this.state.title}
                                        placeholder="建议40字以内，更容易被推荐哦～"
                                        rows="1"
                                        showCounter={true}
                                        onChange={e => this.bindValue(e, 'title')}
                                        maxLength={40}
                                    >
                                    </WKTextarea>
                                </div>
                            </CellBody>
                        </FormCell>
                    </Form>
                </div>

                <div className="lecture-basic-box">
                    <WKGreenTitle title='时间' className="wk-green-specials" />
                    <Form>
                        <FormCell>
                            <CellBody style={{height: '40px'}}>
                                <div className="lecture-basic-box__input">
                                    <Input
                                        className="basic-border"
                                        onFocus={e => this.onFocusTime()}
                                        onChange={e => this.onChangeStartTime(e)}
                                        type="datetime-local"
                                        value={this.state.startTime ? TimeStream(this.state.startTime).replace(' ', 'T') : ''}
                                    />
                                </div>
                            </CellBody>
                        </FormCell>
                    </Form>
                </div>

                <div className="lecture-basic-box">
                    <WKGreenTitle title='课件' className="wk-green-specials" />
                    <Form>
                        <FormCell className="select-cell" onClick={e => this.onChangeModeRadio(e, 'picture')}>
                            <CellBody>
                                <span className={`weui-icon-checked ${this.state.mode === "picture" ? "lecture-basic-box__checked" : "lecture-basic-box__unchecked"}`}/>
                                <span className="lecture-basic-box__mode">无</span>
                            </CellBody>
                        </FormCell>
                        <FormCell className="select-cell" onClick={e => this.onChangeModeRadio(e, 'ppt')}>
                            <CellBody>
                                <span className={`weui-icon-checked ${this.state.mode === "ppt" ? "lecture-basic-box__checked" : "lecture-basic-box__unchecked"}`}/>
                                <span className="lecture-basic-box__mode">PPT</span>
                            </CellBody>
                        </FormCell>
                        <span className="example-div" data-id="1" onClick={this.showExample.bind(this)}
                              style={{top: '65px'}}>示例</span>
                        <FormCell className="select-cell" onClick={e => this.onChangeModeRadio(e, 'video')}>
                            <CellBody>
                                <span className={`weui-icon-checked ${this.state.mode === "video" ? "lecture-basic-box__checked" : "lecture-basic-box__unchecked"}`}/>
                                <span className="lecture-basic-box__mode">视频</span>
                            </CellBody>
                        </FormCell>
                        <span className="example-div" data-id="2" onClick={this.showExample.bind(this)}
                              style={{top: '115px'}}>示例</span>
                    </Form>
                </div>

                {this.state.showExample && (
                    <div className="example-dialog" onClick={() => this.setState({showExample: false})}>
                        <img src={this.state.showExamplePic} onClick={(e) => e.stopPropagation()} alt='示例'/>
                        <img
                            src="https://static-1253442168.image.myqcloud.com/picture/6163344_7c67e5ae21bb976b6f1efbc91bf388c2.jpg"
                            className="close-btn" alt='关闭'
                            onClick={() => this.setState({showExample: false})}
                        />
                    </div>
                )}

                <div className="lecture-basic-btn">
                    <Button type="primary" onClick={() => this.handleBasicSubmit()}>下一步</Button>
                </div>
            </div>
        )
    }
}

export default LectureBasic


// WEBPACK FOOTER //
// ./src/components/lectureCreate/LectureBasic.js